module.exports = "https://static.wanderu.com/static/media/homescreen-iphone.85799bda.png";